module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-selector-wrapper",
    style: ([_vm.transform, _vm.active_class])
  }, [_c('input', {
    staticClass: "progress-selector-indicator ind-2",
    class: _vm.selectorClass,
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": _vm.selectorClicked
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-selector-content ind-1 border-bg-rollover"
  }, [_c('div', {
    staticClass: "p max-96"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('arrow', {
    attrs: {
      "type": "next"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1069aef2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/progress_selector.vue
// module id = 594
// module chunks = 1